export default "__VITE_ASSET__a49fe71d__"